// /etsy/success.jsx
import { Button } from "react-bootstrap";
import { useSearchParams, useNavigate } from "react-router-dom";

export default function EtsySuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const shop = params.get("shop_name");

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-emerald-100">
      <div className="bg-white rounded-2xl shadow-xl  max-w-md w-full p-4 text-center animate-fade-in">
        {/* Success Icon */}
        <div className="flex justify-center mb-2">
          <div className="h-16 w-16 flex items-center justify-center rounded-full bg-green-100 animate-pulse">
            <span style={{ fontSize: "40px" }}>✅</span>
          </div>
        </div>

        <h3 className="font-semibold text-gray-800 mb-2">
          Etsy Connected Successfully
        </h3>

        <p className="text-gray-600 mb-6">
          Your shop <span className="font-medium text-gray-800">{shop}</span> is
          now linked and ready to go.
        </p>

        <Button
          onClick={() => navigate("/etsy/list")}
          className="primary-btn px-6 py-2 rounded-full text-white bg-green-500 hover:bg-green-600 transition-colors duration-300"
        >
          Go to Etsy Listings →
        </Button>
      </div>

      {/* Simple fade-in animation */}
      <style>
        {`
          .animate-fade-in {
            animation: fadeInUp 0.6s ease-out both;
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(16px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
}
